import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authServices from "../services/authServices";

export const loginAdmin = createAsyncThunk(
  "auth/loginAdmin",
  async (data, { rejectWithValue }) => {
    try {
      const res = await authServices.login(data);
      return res;
    } catch (err) {
      const msg =
        typeof err === "string" && err.trim()
          ? err.trim()
          : err?.message || "Login failed";
      return rejectWithValue(msg);
    }
  }
);

export const forgotAdmin = createAsyncThunk("/forgot", async (data) => {
  const res = await authServices.forgot(data);
  return res;
});

export const verifyAdminOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (data, { rejectWithValue }) => {
    try {
      const res = await authServices.verifyOtp(data);
      return res;
    } catch (err) {
      return rejectWithValue({
        message: err?.message || "OTP verify failed",
        status: err?.status,
        messageCode: err?.messageCode || "",
      });
    }
  }
);

export const resetPassword = createAsyncThunk("/reset", async (data) => {
  const res = await authServices.reset(data);
  return res;
});

export const changePassword = createAsyncThunk(
  "changePassword",
  async (data) => {
    const res = await authServices.changePassword(data);
    return res;
  }
);
export const updateFCMToken = createAsyncThunk(
  "updateFcmToken",
  async (data) => {
    const res = await authServices.updateToken(data);
    return res;
  }
);

/**
 * Creates a Redux slice for the 'auth' state.
 * @param {object} config - The configuration object for the slice.
 * @param {string} config.name - The name of the slice.
 * @param {object} config.initialState - The initial state of the slice.
 * @param {any} config.initialState.login - The initial value for the 'login' property.
 * @param {boolean} config.initialState.isLoading - The initial value for the 'isLoading' property.
 * @param {any} config.initialState.error - The initial value for the 'error' property.
 * @param {any} config.initialState.forgot - The initial value for the 'forgot' property.
 */
const authSlice = createSlice({
  name: "auth",
  initialState: {
    loginResponse: null,
    loginErrorMessage: "",
    forgotResponce: [],
    forgotErrorMessage: "",
    verifyOtpResponse: null,
    verifyOtpError: null,
    resetResponce: [],
    resetErrorMessage: "",
    changePasswordResponce: [],
    changePasswordError: "",
    updateFCMTokenResponse: [],
    updateFCMTokenError: "",

    error: null,
    response: null,
    resetPassword: null,
    isLoading: false,
  },
  reducers: {
    clearAuth: (state) => {
      state.loginResponse = null;
      state.loginErrorMessage = "";
    },
  },
  extraReducers: (builder) => {
    // login
    builder
      .addCase(loginAdmin.pending, (state) => {})
      .addCase(loginAdmin.fulfilled, (state, action) => {
        const payload = action?.payload;
        const data =
          payload?.data && typeof payload.data === "object"
            ? payload.data
            : payload;
        state.loginResponse = data
          ? {
              ...data,
              role: data?.role ?? data?.user?.role,
            }
          : null;
      })
      .addCase(loginAdmin.rejected, (state, action) => {
        state.loginErrorMessage =
          action?.payload ?? action?.error?.message ?? "";
      });

    // forgotPassword
    builder
      .addCase(forgotAdmin.pending, (state) => {})
      .addCase(forgotAdmin.fulfilled, (state, action) => {
        state.forgotResponce = action?.payload;
      })
      .addCase(forgotAdmin.rejected, (state, action) => {
        state.forgotErrorMessage = action?.error;
      });

    builder
      .addCase(verifyAdminOtp.pending, (state) => {
        state.verifyOtpError = null;
      })
      .addCase(verifyAdminOtp.fulfilled, (state, action) => {
        state.verifyOtpResponse = action.payload;
      })
      .addCase(verifyAdminOtp.rejected, (state, action) => {
        state.verifyOtpError = action.payload ?? action.error;
      });
    // resetPassword

    builder
      .addCase(resetPassword.pending, (state) => {})
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.resetResponce = action?.payload;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.resetErrorMessage = action?.error;
      });

    // changePassword

    builder
      .addCase(changePassword.pending, (state) => {})
      .addCase(changePassword.fulfilled, (state, action) => {
        state.changePasswordResponce = action?.payload;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.changePasswordError = action?.error;
      });

    builder
      .addCase(updateFCMToken.pending, (state) => {})
      .addCase(updateFCMToken.fulfilled, (state, action) => {
        state.changePasswordResponce = action?.payload;
      })
      .addCase(updateFCMToken.rejected, (state, action) => {
        state.changePasswordError = action?.error;
      });
  },
});

export const { clearAuth } = authSlice.actions;
export default authSlice.reducer;
